import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// eslint-disable-next-line no-restricted-imports -- allowed because this module is a proxy for CmxWebComponentsModule and related directives.
import { CmxWebComponentsModule } from '@cmx-web-components/angular';
import { UiUxTableWrapperProviderDirectiveModule } from '@shared/ui-ux-components/directives/ui-ux-table-wrapper-provider-directive.module';
import { UiUxInputNumberProviderDirectiveModule } from '@shared/ui-ux-components/directives/ui-ux-input-number-provider-directive.module';

/**
 * ⚠️ USE THIS MODULE instead of importing CmxWebComponentsModule directly.
 *
 * Import: `import { ArkikWebComponentsModule } from '@core/modules';`
 *
 * This proxy module bundles:
 * - CmxWebComponentsModule (web components)
 * - UiUxTableWrapperProviderDirectiveModule
 * - UiUxInputNumberProviderDirectiveModule
 *
 * Direct import of CmxWebComponentsModule is restricted.
 * Enforced by: `npm run lint:cwc` and pre-commit hook.
 */
@NgModule({
  imports: [
    CommonModule,
    CmxWebComponentsModule,
    UiUxTableWrapperProviderDirectiveModule,
    UiUxInputNumberProviderDirectiveModule,
  ],
  exports: [CmxWebComponentsModule, UiUxTableWrapperProviderDirectiveModule, UiUxInputNumberProviderDirectiveModule],
})
export class ArkikWebComponentsModule {}
